/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseCourseStudentData } from './genericApiResponseCourseStudentData';
import type { GenericApiResponseCourseStudentMessage } from './genericApiResponseCourseStudentMessage';
import type { GenericApiResponseCourseStudentPagination } from './genericApiResponseCourseStudentPagination';
import type { GenericApiResponseCourseStudentError } from './genericApiResponseCourseStudentError';

export interface GenericApiResponseCourseStudent {
  data?: GenericApiResponseCourseStudentData;
  message?: GenericApiResponseCourseStudentMessage;
  pagination?: GenericApiResponseCourseStudentPagination;
  error?: GenericApiResponseCourseStudentError;
  statusCode?: number;
}
